import {Component, Inject, Input} from '@angular/core';
import {MatDialog, MatDialogRef, MatDialogModule, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import { AuthService, User } from '@auth0/auth0-angular';
import { environment } from 'src/environments/environment';
import { ssoTargetsFor } from 'src/app/sso-targets';

@Component({
  selector: 'ngx-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css'],
  //standalone: true,
})
export class ConfirmDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public auth: AuthService, ) {}

  ///Log User out
  Logout() : void
  {
    //SET a time out
    ///Log User out
        //this.auth.logout();
        //this.auth.logout({ logoutParams: {returnTo: environment.auth.logoutUri, federated: true} });
        // Per-host, like every logout here (src/app/sso-targets.ts).
        this.auth.logout({ logoutParams: {returnTo: ssoTargetsFor(environment).logoutUri} });
  }


}
